import '../scss/main.scss';

import { initNavigation } from './modules/navigation.js';
import { initBackToTop } from './modules/back-to-top.js';
import { initStickyHeader } from './modules/sticky-header.js';
import { initSwiperCarousel } from './modules/swiper-carousel.js';

document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initBackToTop();
  initStickyHeader();
  initSwiperCarousel();
});
